import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import CustomerAskTheExpertJsx from './userManage.jsx'

export default class AskTheExpert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: null,
            isLoading: false,
            selectedUsers: [],
            totalCount: 0,
            currentPage: 1,
            totalPages: 1,
            showModal: false,
            modalMode: 'add', // 'add' or 'edit'
            currentUser: null,
            roles: [],
            formData: {
                name: '',
                email: '',
                phoneNumber: '',
                userType: 'marketing',
                roleId: ''
            }
        }
    }

    // Handle user selection
    handleUserSelection = (userId, isSelected) => {
        let updatedSelectedUsers;
        
        if (isSelected) {
            // Add user to selected list if not already present
            const exists = this.state.selectedUsers.includes(userId);
            if (!exists) {
                updatedSelectedUsers = [...this.state.selectedUsers, userId];
            } else {
                updatedSelectedUsers = this.state.selectedUsers;
            }
        } else {
            // Remove user from selected list
            updatedSelectedUsers = this.state.selectedUsers.filter(id => id !== userId);
        }

        this.setState({
            selectedUsers: updatedSelectedUsers
        });
    };

    // Handle bulk operations on selected users
    handleBulkAction = (action) => {
        let token = JSON.parse(localStorage.getItem('token'));

        if (this.state.selectedUsers.length === 0) {
            toast.warning('Please select at least one user');
            return;
        }

        const data = {
            "userIds": this.state.selectedUsers,
            "action": action
        }
        
        this.setState({ isLoading: true });

        axios.post(`${baseURL}/users/bulk-action`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.setState({ isLoading: false });
            toast.success(`${action} operation completed successfully`);
            this.loadUsers(); // Reload users after action
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err.response?.data?.error?.message || 'Operation failed');
        });
    };

    // Load users with pagination
    loadUsers = (page = 1) => {
        this.setState({ isLoading: true });
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/users?page=${page}`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const { data, meta } = res.data;
            
            this.setState({ 
                userData: data,
                totalCount: meta.totalCount,
                currentPage: page,
                totalPages: meta.totalPages,
                isLoading: false 
            });
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err.response?.data?.error?.message || 'Failed to load users');
        });
    };

    // Load roles for dropdown
    loadRoles = () => {
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/roles`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ roles: res.data.data });
        }).catch(err => {
            toast.error('Failed to load roles');
        });
    };

    // Handle page change
    handlePageChange = (page) => {
        if (page >= 1 && page <= this.state.totalPages) {
            this.loadUsers(page);
        }
    };

    // Show add user modal
    showAddUserModal = () => {
        this.setState({
            showModal: true,
            modalMode: 'add',
            currentUser: null,
            formData: {
                name: '',
                email: '',
                phoneNumber: '',
                userType: 'marketing',
                roleId: ''
            }
        });
    };

    // Show edit user modal
    showEditUserModal = (user) => {
        this.setState({ isLoading: true });
        let token = JSON.parse(localStorage.getItem('token'));
        
        // Fetch user details for editing
        axios.get(`${baseURL}/user/${user.userId}`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const userData = res.data.data;
            this.setState({
                showModal: true,
                modalMode: 'edit',
                currentUser: userData,
                formData: {
                    name: userData.name || '',
                    email: userData.email || '',
                    phoneNumber: userData.phoneNumber || '',
                    userType: userData.userType || 'marketing',
                    roleId: userData.roleId || ''
                },
                isLoading: false
            });
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error('Failed to load user details');
        });
    };

    // Close modal
    closeModal = () => {
        this.setState({
            showModal: false,
            modalMode: 'add',
            currentUser: null,
            formData: {
                name: '',
                email: '',
                phoneNumber: '',
                userType: 'marketing',
                roleId: ''
            }
        });
    };

    // Handle form input changes
    handleInputChange = (field, value) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [field]: value
            }
        });
    };

    // Handle form submission
    handleSubmit = (e) => {
        e.preventDefault();
        
        const { formData, modalMode, currentUser } = this.state;
        let token = JSON.parse(localStorage.getItem('token'));

        // Validation
        if (!formData.name || !formData.email || !formData.roleId) {
            toast.error('Please fill in all required fields');
            return;
        }

        this.setState({ isLoading: true });

        const submitData = {
            name: formData.name,
            email: formData.email,
            userType: formData.userType,
            phoneNumber: formData.phoneNumber,
            roleId: parseInt(formData.roleId)
        };

        const apiCall = modalMode === 'add' 
            ? axios.post(`${baseURL}/user`, submitData, {
                headers: { 'x-access-token': token }
              })
            : axios.put(`${baseURL}/user/${currentUser.userId}`, submitData, {
                headers: { 'x-access-token': token }
              });

        apiCall.then(res => {
            this.setState({ isLoading: false });
            toast.success(`User ${modalMode === 'add' ? 'created' : 'updated'} successfully`);
            this.closeModal();
            this.loadUsers(this.state.currentPage);
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err.response?.data?.error?.message || `Failed to ${modalMode} user`);
        });
    };

    componentDidMount = () => {
        this.loadUsers();
        this.loadRoles();
    }

    render() {
        return (
            <div>
                <CustomerAskTheExpertJsx
                    userData={this.state.userData}
                    selectedUsers={this.state.selectedUsers}
                    handleUserSelection={this.handleUserSelection}
                    handleBulkAction={this.handleBulkAction}
                    currentPage={this.state.currentPage}
                    totalPages={this.state.totalPages}
                    totalCount={this.state.totalCount}
                    handlePageChange={this.handlePageChange}
                    showAddUserModal={this.showAddUserModal}
                    showEditUserModal={this.showEditUserModal}
                    showModal={this.state.showModal}
                    modalMode={this.state.modalMode}
                    formData={this.state.formData}
                    roles={this.state.roles}
                    handleInputChange={this.handleInputChange}
                    handleSubmit={this.handleSubmit}
                    closeModal={this.closeModal}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}